
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { PlatformOverview } from './PlatformOverview';
import { PlatformDetails } from './PlatformDetails';
import { DashboardHeader } from './DashboardHeader';
import { Facebook, Instagram, Youtube, Linkedin } from 'lucide-react';

const platforms = [
  {
    id: 'all',
    name: 'All Platforms',
    icon: null,
    color: 'bg-gradient-to-r from-purple-500 to-pink-500',
  },
  {
    id: 'facebook',
    name: 'Facebook',
    icon: Facebook,
    color: 'bg-blue-600',
  },
  {
    id: 'instagram',
    name: 'Instagram',
    icon: Instagram,
    color: 'bg-gradient-to-r from-pink-500 to-orange-500',
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    icon: null,
    color: 'bg-black',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    icon: Youtube,
    color: 'bg-red-600',
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    icon: Linkedin,
    color: 'bg-blue-700',
  },
];

export const SocialMediaDashboard = () => {
  const [activeTab, setActiveTab] = useState('all');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <DashboardHeader />
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <TabsList className="grid w-full grid-cols-6 bg-slate-100 p-1 rounded-lg">
              {platforms.map((platform) => (
                <TabsTrigger
                  key={platform.id}
                  value={platform.id}
                  className="flex items-center gap-2 px-4 py-2 rounded-md transition-all duration-200 data-[state=active]:bg-white data-[state=active]:shadow-sm"
                >
                  {platform.icon && <platform.icon className="w-4 h-4" />}
                  <span className="hidden sm:inline">{platform.name}</span>
                  <span className="sm:hidden">{platform.name.split(' ')[0]}</span>
                </TabsTrigger>
              ))}
            </TabsList>
          </div>

          <TabsContent value="all" className="space-y-6">
            <PlatformOverview platforms={platforms.slice(1)} />
          </TabsContent>

          {platforms.slice(1).map((platform) => (
            <TabsContent key={platform.id} value={platform.id} className="space-y-6">
              <PlatformDetails platform={platform} />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
};
